<template>
<div class="exchange">
  <div class="success" v-show="successShow" @click="successShow = false">
     <div class="successMain" @click.stop="">
        <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/exchangeSuccess.png"/>
        <b>恭喜您，兑换成功</b>
        <p>京学高研院会员</p>
        <button @click="toPage"><img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/exchangeStart.png"/></button>
     </div>
  </div>
  <div class="top">
    <examin-header title=""></examin-header>
    <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/exchangeTopBg.png"/>
  </div>
  <div class="main">
      <div class="input">
         <input v-model="code" placeholder="请输入课程兑换码"/>
        <scan class="scan" @scanResult="scanResult"></scan>
      </div>
      <button class="btn" :class="{red:code}" @click="submit">立即兑换</button>
      <div class="rule">
         <div class="title">
           <img :src="title"/>
           兑换规则
         </div>
         <div class="cont">
           <span>1、</span>
           <p>兑换码是由高研院/研修社通过特定渠道后进行兑换的一种形式；</p>
         </div>
         <div class="cont">
           <span>2、</span>
           <p>兑换成功后，对应课程信息会同步到您的个人账户中；</p>
         </div>
         <div class="cont">
           <span>3、</span>
           每个兑换码可兑换一次，不可重复使用；
         </div>
         <div class="cont">
           <span>4、</span>
           <p>如有问题请咨询京学高研院官方客服：<br/>
           电话：<a href="tel:13811674685">13811674685</a><br/>
           微信：pkucollegeIT</p>
         </div>
      </div>
  </div>
</div>
</template>

<script>
  import { Toast } from 'vant';
import ExaminHeader from '../components/ExaminHeader2.vue';
  import scan from '../components/scan.vue';
export default {
  name: "exchange",
  data() {
    return {
      successShow:false,
      code:'',
      
      title:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/exchangeTitle.png'
    }
  },
  components:{
    ExaminHeader,
    scan
  },
  mounted() {
   
  },
  destroyed() {},
  computed: {
    plat() {
      return this.$store.state.plat_id
    }
  },
  methods: {
    submit(){
      if(!this.code) return Toast('请输入课程兑换码')
      this.$request.exchangeLesson({code:this.code}).then(res=>{
    
          this.successShow = true
        
      })
    },
    scanResult(text){
      
        let info = text.split('?')[1].split('&')
        info.forEach(item=>{
          if(item.split('=')[0]=='code') this.code = item.split('=')[1]
        })
      
    },
    toPage() {
      this.$router.push('./user/purchased')
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    // console.log(to)
    next()
  },

};
</script>

<style lang="scss" scoped>
.exchange {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #F9F9F9;
  background-size: contain;
  box-sizing: border-box;
  .success{
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top:0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0,0,0,0.6);
    backdrop-filter: blur(6px);
    .successMain{
      width: 560px;
      height: 600px;
      background: #FFFFFF;
      border-radius: 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      >img{
        width: 164px;
        margin-top: 75px;
        margin-bottom: 41px;
      }
      b{
        font-size: 32px;
        color: #1E2531;
      }
      p{
        color: #666666;
        font-size: 28px;
        padding-top: 15px;
        padding-bottom: 50px;
      }
      button {
        background: none;
        border: 0;
        padding: 0;
        img{
          width: 250px;
        }
      }
    }
  }
  .top{
    position: relative;
    img{
      width: 100%;
    }
    .custom-header{
      position: absolute;
    }
  }
  .main{
    z-index: 10;
    flex: 1;
    width: 690px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(63,63,75,0.1);
    border-radius: 20px;
    margin:  -90px auto 90px;
    padding: 60px 36px;
    box-sizing: border-box;
    // overflow-x: hidden;
    // overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    height: 100%;
    .input{
      width: 620px;
      height: 100px;
      background: #F9F9F9;
      border-radius: 50px;
      line-height: 100px;
      margin-bottom: 40px;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      padding: 0 60px;
      input{
        flex: 1;
        width: 100%;
        height: 100%;
        font-size: 32px;
        color: #666666;
        border: 0;
        text-align: center;
        background: none;
      }
    }
    .btn{
      width: 100%;
      height: 100px;
      background: #E2E2E2;
      border-radius: 50px;
      margin: 0 auto;
      border: 0;
      font-size: 36px;
      color: #BEBEBE;
    }
    .red{
      background: #E02020;
      color: #FFFFFF;
    }
    .rule{
      padding-top: 100px;
      .title{
        display: flex;
        align-items: center;
        font-size: 36px;
        color: #333333;
        margin-bottom: 20px;
        img{
          width: 11px;
          height: 44px;
          margin-right: 8px;
          margin-left: 14px;
        }
      }
      .cont{
        color: #666666;
        font-size: 28px;
        line-height: 48px;
        margin-bottom: 24px;
        display: flex;
        padding-left: 13px;
        a{
          color: #666666;
        }
      }
    }
  }

}
</style>

